import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuctionDetails, AuctionRound, Photo } from 'src/app/services/portal-api.service';
import { ModalService } from '@indice/ng-components';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MobileViewModalComponent } from './mobile-view-modal/mobile-view-modal.component';
import { mergeMap, of } from 'rxjs';

@Component({
  selector: 'app-filter-property-dropdown',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './filter-property-dropdown.component.html',
  styleUrl: './filter-property-dropdown.component.css',
})
export class FilterPropertyDropdownComponent {
  @Output() propertySelected = new EventEmitter<{id:string, auctionDetails?:AuctionDetails}>();
  @Input() dropdownItems: FilterDropdownPropertyItem[] = [];
  @Input() labelName: string = '';
  @Input() inputPlaceholder: string = 'Selection';
  @Input() maxHeightOnDropdownOpen: '40' | '52' | '80' = '52';
  @Input() isRequired = true;
  public selectedDropdownItem: FilterDropdownPropertyItem | null = null;
  public isDropdownOpen = false;
  public isModalOpen = false;
  constructor(private _modalService: ModalService, private _translate: TranslocoService) {}

  toggleDropdown() {
    const isMobileView = window.innerWidth <= 768;
    if (isMobileView) {
      this.isDropdownOpen = false;
      this.mobileViewModalCase(this.dropdownItems);
    } else {
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }

  selectDropdownItem(item: FilterDropdownPropertyItem) {
    this.isDropdownOpen = false;
    this.selectedDropdownItem = item;
    this.dropdownItems.map((i) => (i.key == item.key ? (i.checked = true) : (i.checked = false)));

    // Send selected item to parent
    this.propertySelected.emit({ id:item.key,auctionDetails:item.auctions });
  }

  mobileViewModalCase(dropdownItems: FilterDropdownPropertyItem[]) {
    const mobileModal = this._modalService.show(MobileViewModalComponent, {
      keyboard: true,
      class: 'h-dvh md:h-auto',
      initialState: {
        labelName: this.labelName,
        dropdownItems: dropdownItems,
        selectedModalItem: this.selectedDropdownItem,
      },
    });

    mobileModal.onHidden?.pipe(
      mergeMap((x: any) => {
        if (x.result.dropdownItems) {
          this.dropdownItems = x.result.dropdownItems;
          this.selectedDropdownItem = x.result.selectedModalItem;
          // Send selected item key to parent
          this.propertySelected.emit({id:this.selectedDropdownItem?.key ?? '', auctionDetails:this.selectedDropdownItem?.auctions});
        }
        return of();
      }),
    )
    .subscribe();
  }
}

export interface FilterDropdownPropertyItem {
  key: string;
  title?: string;
  address?: string;
  extraInfo?: string;
  constructionYear?: string,
  floor?: number,
  bedrooms?: number,
  bathrooms?: number,
  defaultPhoto?: Photo;
  checked?: boolean;
  auctions?:AuctionDetails
}
